export default [
    {
        path: '/transfer-request/create-transfer-request',
        name: 'transfer_request_create_transfer_request',
        component: () => import('@src/transfer-request/create-transfer-request.vue'),
        meta: {
            title: 'Umlagerungsauftrag anlegen',
            role: 'ROLE_CREATE_TRANSFER_REQUEST',
        },
    },
    {
        path: '/transfer-request/list/open',
        name: 'transfer_request_list_open',
        component: () => import('@src/transfer-request/transfer-request-list-open.vue'),
        meta: {
            title: 'Offene Umlagerungsaufträge',
            role: 'ROLE_SHOW_TRANSFER_REQUEST',
        },
    },
    {
        path: '/transfer-request/detail/:id',
        name: 'transfer_request_detail',
        component: () => import('@src/transfer-request/transfer-request.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Umlagerungsauftrag - Detail',
            role: 'ROLE_SHOW_TRANSFER_REQUEST',
        },
    },
    {
        path: '/transfer-request/search',
        name: 'transfer_request_search',
        component: () => import('@src/transfer-request/search-transfer-request.vue'),
        meta: {
            title: 'Umlagerungsaufträge suchen',
            role: 'ROLE_SHOW_TRANSFER_REQUEST',
        },
    },
];
